import { yourJourneySelectors } from '@store/yourJourney';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { guestSelectors } from '@store/guest/selectors';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { SpaTreatmentConfigWizard } from './SpaTreatmentConfigWizard';

const mapStateToProps = (state) => ({
  guest: guestSelectors.getGuest(state),
  isSpinnerVisible: basketSelectors.getIsBasketDetailsFetching(state),
  selectedTimeSlot: formValueSelector('spaEntityConfigurationForm')(state, 'arrivalTime'),
  spaPage: entitySelectors.getSpaPage(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const TreatmentConfigWizardContainer: any =
  connect(mapStateToProps)(SpaTreatmentConfigWizard);
